import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import desktopImage from '../../../assets/images/backoffice/finup/finup.png';
import mobileImage from '../../../assets/images/backoffice/finup/finupMobile.png';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import { CheckText } from '../../../components/common/CheckText';
import { Hub } from '../../../components/common/Hub/Hub';
import Spinner from '../../../components/common/Spinner';
import { getUserTickets } from '../../../slices/auth-slice';
import { H3, P1 } from '../../../styles/FontStyles';
import { Button, Flexed, PageTitle } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Desktop, Mobile } from '../../Kyc/KycStyled';
import { getFinUp } from '../Marketplace.actions';
import { StakingHubDetailsStyled } from '../Marketplace.styled';
import { PurchasePackageAndCombo } from '../PurchasePackageAndCombo/PurchasePackageAndCombo';
import { AkashaTitle } from '../PowerPacks/PowerPacks.styled';

export const FinupMembership = () => {
  const dispatch = useDispatch();

  const { loading, hubs } = useSelector((state) => state.marketplace);

  useEffect(() => {
    dispatch(getFinUp());
    dispatch(getUserTickets());
  }, [dispatch]);

  const [selectedHub, setSelectedHub] = useState();
  const [modal, setModal] = useState(false);

  const handleSeeDetails = (hub) => {
    setSelectedHub(hub);
  };

  const handleSelectPackage = (hub) => {
    setModal(true);
    handleSeeDetails(hub);
  };

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'marketplace'}>
      <Desktop>
        <section style={{ position: 'relative' }}>
          <img src={desktopImage} alt='trading' style={{ width: '100%' }} />
        </section>
      </Desktop>

      <Mobile>
        <section style={{ position: 'relative' }}>
          <img src={mobileImage} alt='trading' style={{ width: '100%' }} />
        </section>
      </Mobile>

      <AkashaTitle>
        Start Trading Smarter with FinUp’s AI-Powered Crypto Strategies
      </AkashaTitle>

      <P1 mb='20' mt='40'>
        Unlock the power of FinUp, the all-in-one crypto super app specifically
        designed to massively improve your trading.
      </P1>
      <P1 mb='20'>
        This platform, originally developed for institutional investors like
        banks and funds, is now accessible to everyone, but in a SIMPLE and
        AUTOMATED set of tools, that take work away from you when it comes to
        thousands of hours of data analysis.
      </P1>
      <P1 mb='40'>
        AI Trading technology, that FinUp uses, was refined over 7 years. With a
        proven track record of over 325% gains and more than 88% winning trades
        in the last 18 months, FinUp offers a full set of tools to enter this
        crypto super-cycle ready to turn a profit.
      </P1>

      <PageTitle>
        Access FinUp: Your Gateway to Smarter Crypto Trading
      </PageTitle>

      <Flexed mt='40' rowSM gap={selectedHub !== null ? '100px' : '0'}>
        <Flexed
          column
          width={selectedHub !== null ? '65%' : '100%'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          {hubs?.map((hub) => {
            const {
              packageId,
              image,
              name,
              price,
              priceToShow,
              subtitle,
              tickets
            } = hub;

            return (
              <Hub
                key={packageId}
                image={image}
                showTickets={false}
                title={name}
                price={price}
                priceToShow={priceToShow}
                subtitle={subtitle}
                tickets={tickets}
                onClick={() => handleSeeDetails(hub)}
                selected={selectedHub?.packageId === packageId}
                button={
                  <Button
                    w='200px'
                    wSM='100%'
                    onClick={() => handleSelectPackage(hub)}
                    negative={selectedHub?.packageId !== packageId}>
                    Select Membership
                  </Button>
                }
                stakingHubDetails={<StakingHubDetails hub={hub} />}
              />
            );
          })}
        </Flexed>
        <Flexed
          desktop
          column
          width={selectedHub !== null ? '35%' : '0'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          <div
            style={{
              position: 'sticky',
              top: 200
            }}>
            <AnimatePresence exitBeforeEnter>
              {selectedHub?.packageId &&
                hubs?.map((hub, i) => {
                  if (hub?.packageId === selectedHub?.packageId) {
                    return (
                      <AnimatedTab key={i}>
                        <H3 mb='4' color={color.colors.primary900}>
                          {hub?.name}
                        </H3>
                        <StakingHubDetailsStyled>
                          <StakingHubDetails hub={hub} />
                        </StakingHubDetailsStyled>
                      </AnimatedTab>
                    );
                  } else return null;
                })}
            </AnimatePresence>
          </div>
        </Flexed>
      </Flexed>

      <PurchasePackageAndCombo
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
      />
    </AnimatedDashboard>
  );
};

const StakingHubDetails = ({ hub }) => {
  return (
    <div>
      <P1 semiBold color={color.colors.neutral500} mb='12'>
        FinUp Membership Benefits
      </P1>
      {hub?.membershipBenefits?.map((benefit, i) => (
        <div key={i}>
          <CheckText text={benefit} />
        </div>
      ))}
    </div>
  );
};
